import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FeaturesService {

   //declare variables
   features: any[] = [
    { 
      title: "APIs",
      description: "Provide real-time connectivity with RegScale modules and features",
      why: "You have made investments in your existing systems and our APIs allow you to seamlessly integrate external data sources in any bespoke customer environment.",
      link: "/documentation/apis",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Workflow",
      description: "Our drag and drop workflow builder allows you to configure RegScale to meet your existing business processes.",
      why: "You can automate your manual business processes without needing an Army of developers and months of time to program something to meet your requirements.",
      link: "/documentation/workflow",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Compliance Explorer",
      description: "A Windows Explorer like feature for organizing complex relationships between compliance artifacts.",
      why: "Compliance processes are complicated and we keep everything well organized to help you pass audits.",
      link: "/documentation/explorer",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Catalogues",
      description: "Digitizes regulatory compliance requirements and frameworks so you can map your compliance processes for implementation.",
      why: "No more cutting and pasting regulations, we digitize regulations so you can easily import them into your RegScale system for implementation.",
      link: "/documentation/catalogues",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Scheduling",
      description: "Automated tools for building audit/assessment schedules or scheduling recurring audits, data calls, or tasks.",
      why: "Drive accountability, view progress against the schedule, and ensure you never miss another compliance deadline.",
      link: "/documentation/scheduling",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Evidence Management",
      description: "Provides a secure and encrypted file upload system with the ability to link to external content management systems.",
      why: "Store compliance evidence on the record that is fully AES-256 encrypted, MD5 hashed, and available on demand for auditors.",
      link: "/documentation/evidence",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Custom Fields",
      description: "Extend the RegScale schema with custom fields to capture customer specific data for any compliance process.",
      why: "Extend forms for data collection to exactly match the data required by the customer's business process.",
      link: "/documentation/custom-fields",
      ce: 'fas fa-times-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Multi-Tenancy",
      description: "Provides the ability for a customer to support multiple internal organizations independently within a single RegScale installation.",
      why: "Brings the power of the cloud behind the user firewall allowing CIOs to consolidate compliance systems while meeting the unique needs of each internal customer.",
      link: "/documentation/multi-tenancy",
      ce: 'fas fa-times-circle fa-2x', 
      saas: 'fas fa-times-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Slack/Teams Integrations",
      description: "Collaborate in real-time with with other compliance professionals using your existing collaboration tools.",
      why: "Stream compliance events in real-time to Slack/Teams to allow your compliance professionals to be more productive and pro-active.",
      link: "/documentation/collaboration",
      ce: 'fas fa-times-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "AD/LDAP",
      description: "Authenticate to RegScale using your existing systems such as Active Directory (AD) or Lighweight Directory Access Protocol (LDAP).",
      why: "Reduce the overhead of managing a separate authentication scheme while maximizing your existing security investments in AD/LDAP",
      link: "/documentation/authentication",
      ce: 'fas fa-times-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "History",
      description: "Detailed audit logs to monitor all user activity within the system.",
      why: "Pro-actively monitor security by logging all user activity related to every RegScale record.",
      link: "/documentation/history",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Timeline",
      description: "Build interactive timelines for events related to any RegScale record.",
      why: "No need for Visio, build interactive timelines using our tools to document all related events for a given RegScale record.",
      link: "/documentation/timeline",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "News Feed",
      description: "LinkedIn for Compliance - real-time streaming feed of important compliance events for your organization.",
      why: "Information comes directly to you without complex searching and reporting mechanisms.",
      link: "/documentation/newsfeed",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, {
      title: "Calendar",
      description: "A temporal view of compliance related activity in a Calendar view format.",
      why: "Never miss another due date with a convenient look-ahead calendar for upcoming compliance related events.",
      link: "/documentation/calendar",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Excel Export",
      description: "Easily export and download your data in Excel for external processing.",
      why: "No reporting solution is perfect and we allow you to easily export your data in Excel for custom reporting or more complex data processing.",
      link: "/documentation/excel",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Dashboards",
      description: "Real-time views of compliance status for every RegScale module.",
      why: "Out of the box reporting to visualize the state of compliance against all RegScale modules including time visualizations, graphs, and expired/upcoming lists.",
      link: "/documentation/dashboards",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Email",
      description: "Send compliance notifications to your employees and stakeholders via email.",
      why: "We know many of your employees live in Outlook and we support emailing all records via SMTP to Outlook or other email clients.",
      link: "/documentation/email",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Workbench",
      description: "Single pane of glass view of all upcoming compliance activities for a given user.",
      why: "With the wide array of compliance modules available in RegScale, we provide a simple way to view all compliance related deliverables that require your attention.",
      link: "/documentation/workbench",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Builders",
      description: "An intuitive wizard for rapidly building compliance artifacts.",
      why: "Next->Next->Finish wizard-style approach to build compliance artifacts in minutes that map to dozens of related regulations.",
      link: "/documentation/builders",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Metadata",
      description: "Customize picklists in forms with your organization's metadata.",
      why: "We understand that you have unique and finely tuned business processes that rely on collecting specific data.  We allow you to tune our picklists to meet your specific metadata requirements.",
      link: "/documentation/metadata",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "ISO Appliance",
      description: "The simplest deployment process possible.  Be up in running in minutes in any VMware, Hyper-V, or cloud environment.",
      why: "The lowest possible Operations and Maintenance (O&M) cost with a pre-package ISO appliance, easy to use CLI, and next to nothing to manage on the customer end.",
      link: "/documentation/appliance",
      ce: 'fas fa-times-circle fa-2x', 
      saas: 'fas fa-times-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "GIS Maps",
      description: "View the status of compliance with a fly-over GIS map.",
      why: "For large distributed enterprises, view the status of compliance for all of your facilities (physical locations) within a Google Maps view.",
      link: "/documentation/gis",
      ce: 'fas fa-times-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "@Mentions",
      description: "Integrated notification system using @mentions to notify users for any new comments, workflow actions, or News Feed threads.",
      why: "Familiar notification system used by Slack, Teams, Facebook, and others to provide real-time collaboration via intuitive notifications.",
      link: "/documentation/mentions",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, {
      title: "3rd Party Risk",
      description: "Provides a calculated risk score across multiple factors for a company's supply chain contracts and/or vendors",
      why: "Allows companies to take pro-active risk mitigations and to avoid audit fines and non-compliances",
      link: "/documentation/thirdpartyrisk",
      ce: 'fas fa-times-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, {
      title: "Advanced Reporting",
      description: "Purpose built and specialized reports that provide out of the box support for common regulatory reporting requirements.",
      why: "We provide purpose built reports that save our Enterprise customers time and money on complex regulatory reporting.",
      link: "/documentation/advancedreporting",
      ce: 'fas fa-times-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, {
      title: "Relationship Manager",
      description: "Provides the ability to establish non-heirarchical relationships between records.",
      why: "Supports many to many relational modeling for documenting complex interactions between modules/records.",
      link: "/documentation/relationships",
      ce: 'fas fa-times-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, {
      title: "Risk Management Framework (RMF)",
      description: "Provides the ability to model risk and mitigations that is aligned to control implementations as mitigations.",
      why: "Allows modeling and visualization of how investments in improving security controls directly impacts risk.",
      link: "/documentation/rmf",
      ce: 'fas fa-times-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, {
      title: "Transformer",
      description: "Provides the ability to map controls across frameworks and toggle versions of security plans.",
      why: "Allows customers to select which version of a plan they want to print and toggle between different frameworks.",
      link: "/documentation/transformer",
      ce: 'fas fa-times-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, {
      title: "Service Accounts",
      description: "Provides secure and long running tokens to allow access to APIs",
      why: "Allows customers to programmatically access APIs without the use of usernames and passwords thereby improving security",
      link: "/documentation/service-accounts",
      ce: 'fas fa-times-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Time Travel",
      description: "Immutable version control system for low level change tracking between record versions",
      why: "View precise changes between versions of records over time with cryptographic protections ensuring that data is not altered in any way.",
      link: "/documentation/timetravel",
      ce: 'fas fa-times-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Categorization",
      description: "Questionnaire driven approach for building dynamic profiles that can be applied to RegScale organizer modules",
      why: "Allows organizations to precisely tailor controls/requirements based on questions and answers while avoiding creating 'to the n' numbers of profiles.",
      link: "/documentation/categorization",
      ce: 'fas fa-times-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Inheritance",
      description: "Provides the ability to easily tier controls by policy or security plan to support inheritance models",
      why: "Allows organizations to minimize rework for lower level systems by inheriting controls efficiently from other policies or security plans",
      link: "/documentation/inheritance",
      ce: 'fas fa-times-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Classification",
      description: "Provides the ability to define sensitivity labels for data and to appropriately mark records in RegScale",
      why: "Allows for properly marking data for printing/export as well as data tagging to support Data Loss Prevention (DLP) programs",
      link: "/documentation/classification",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }
  ];

  //inject services
  constructor() {}

  //returns the list of features
  getFeatures() {
    //sort by name
    this.features.sort((a, b) => a.title < b.title ? -1 : a.title > b.title ? 1 : 0);
    return this.features;
  }

}
